import { combineReducers } from 'redux'

import { arrayOfObjectsToObject } from 'utils/helpers'

import {
  DATA_REQUEST_ASYNC,
  FORM_RESET,
  GROUP_TOGGLE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SELECT_ALL,
  SET_INTEGRATION_TYPE,
  SHARED_MAILBOXES_CHANGE,
  SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC,
  SYNC_ALL_UPDATE,
  UNSELECT_ALL,
} from './constants'

function customizedAutoSyncReducer() {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    integrationType: null,
    search: '',
    interactedGroups: [], // [{ id, displayName }]
    syncAll: true,
    includeSharedMailboxes: false,
    page: 1,
    excludeMode: false,
    /**
     * This flag exists in order to merge functionality
     * of user's interaction and data coming from server
     * 1) @excludeMode
     * 2) @interactedGroups
     * Idea is to consider BE data only until
     * user changed the @excludeMode so @ignoreBE flag
     * became true and no changes (mode and interacted groups)
     * from the server gonna be applied to the form.
     */
    ignoreBE: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case FORM_RESET: {
        return initialState
      }
      case SELECT_ALL: {
        return {
          ...state,
          excludeMode: true,
          interactedGroups: [],
          ignoreBE: true,
        }
      }
      case UNSELECT_ALL: {
        return {
          ...state,
          excludeMode: false,
          interactedGroups: [],
          ignoreBE: true,
        }
      }
      case SYNC_ALL_UPDATE: {
        return {
          ...state,
          syncAll: !state.syncAll,
          // interactedGroups: [],
        }
      }
      case SHARED_MAILBOXES_CHANGE: {
        return {
          ...state,
          includeSharedMailboxes: !state.includeSharedMailboxes,
        }
      }
      case GROUP_TOGGLE: {
        const interactedGroup = state.interactedGroups.filter(
          (g) => g.id === action.payload.group.id
        )
        return {
          ...state,
          interactedGroups: interactedGroup.length
            ? state.interactedGroups.filter((g) => g.id !== action.payload.group.id)
            : [...state.interactedGroups, action.payload.group],
        }
      }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case DATA_REQUEST_ASYNC.SUCCESS: {
        const newState = {
          ...state,
          loader: false,
          data: action.payload.data,
        }

        // only once form is open
        if (!Object.keys(state.data).length) {
          newState.excludeMode = action.payload.data.excludeMode
          newState.includeSharedMailboxes = action.payload.data.syncShared
          // assuming that server returning ordered groups
          // (interacted first) we're selecting relevant mode
          newState.syncAll = !action.payload.data.groups.filter((group) => group.selected).length
        }

        if (!state.ignoreBE) {
          const mapInteractedGroups = arrayOfObjectsToObject(newState.interactedGroups, 'id')
          newState.interactedGroups = [
            ...newState.interactedGroups,
            ...action.payload.data.groups.filter(
              (group) => group.selected && !mapInteractedGroups[group.id]
            ),
          ]
        }

        return newState
      }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error?.response?.message }
      case DATA_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
        }
      case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.SUCCESS:
        return { ...state, loader: false }
      case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.ERROR:
        return { ...state, error: action.error?.response?.message }
      case SET_INTEGRATION_TYPE:
        return {
          ...state,
          integrationType: action.payload.val,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
        }
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
          page: 1,
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          page: 1,
          loader: true,
        }
      default:
        return state
    }
  }
}

export default function () {
  const initialState = combineReducers({
    self: customizedAutoSyncReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
